<template>
    <div class="techer-info-home">
        <div class="top">
            <div class="top-title">Schedule</div>
            <div></div>
            <div class="calendar-box">
                <div style="width:324px;">
                    <div class="calendar-header">
                        <div>{{currentDate}}</div>
                        <div>
                            <i class="el-icon-arrow-left" @click="preMonth" :class="{'can-select':canGoPre}"></i>
                            <i class="el-icon-arrow-right" @click="nextMonth"></i>
                        </div>
                    </div>
                    <el-calendar v-model="selectedDay" ref="teacher-home-calendar" :first-day-of-week="7">
                        <template slot="dateCell" slot-scope="{date, data}">
                            <span :class="teacherCalendar.some(a=>a.apdate === data.day) ? 'has-course' : ''">
                                {{parseInt(data.day.split('-')[2])}}
                            </span>
                        </template>

                    </el-calendar>
                </div>
                <div class="top-course">
                    <div class="calendar-header">
                        <div>{{currentDate}}</div>
                    </div>
                    <div class="course-by-date-box">
                        <div class="course-by-date-item" v-for="item,index in teacherCourseByDate" :key="index" :class="{item_l:index%2===0,item_r:index%2===1}">
                            <div class="c-title" :title="item['covey_course.courseName']">{{item['covey_course.courseName']}}</div>
                            <div class="c-time">{{item.starttime+'-'+item.endtime}}</div>
                        </div>
                        <div v-if="teacherCourseByDate.length===0" style="color:#c1c1c1;">
                            No Datas
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <h2>Upcoming classes</h2>
        <!-- 展示一节课下的每一次课 -->
        <div class="teach-course-information">
            <div class="list-head">
                <div class="flex_1">Index</div>

                <div class="flex_2">Info</div>

                <div class="flex_2">Course</div>
                <div class="flex_3">Student</div>
                <div class="flex_4">Time</div>
                <div class="flex_3">Status</div>
                <div class="flex_4">Operation</div>
            </div>
            <div class="list-content" v-for="item,index of recentCourse" :key="index">
                <div class="flex_1">{{index+1}}</div>

                <div class="flex_2">
                    <div>Class ID:{{item.id}}</div>
                    <div>Order ID:{{item.covey_order.id}}</div>
                </div>
                <div class="flex_2 limit-length" :title="item.covey_course.courseName">{{item.covey_course.courseName}}</div>
                <div class="flex_3 limit-length">{{item.covey_user?item.covey_user.realname:''}}</div>
                <div class="flex_4">{{format(item.apdate,'ddd, MMM. Do, YYYY')+' '+item.starttime+'-'+item.endtime}}</div>
                <div class="flex_3 flex-box">
                    <img style="margin-right:8px;" :src="statusMap[item.status]" />
                    <span>{{lessonMap[item.status]}}</span>
                </div>
                <div class="flex_4 operation">
                    <div v-if="[0,1].includes(parseInt(item.status))" @click="openCourseAddressDialog(item)"><span>Course address</span></div>
                    <div v-if="parseInt(item.status)=== 1" @click="beginClass(item)"><span>Begin session</span></div>
                    <div v-if="parseInt(item.status)=== 3" @click="finishClass(item)"><span>End session</span></div>
                </div>
            </div>

            <div v-if="recentCourse.length<5">
                <div class="list-content" v-for="index in (5-recentCourse.length)" :key="index"></div>
            </div>
        </div>

        <KtPag :pageCount="defaultParams.count" :currentPage="defaultParams.page" :limit="defaultParams.limit" @onChange="onPageChange"></KtPag>

        <el-dialog custom-class="course-address-dialog" :visible.sync="courseAddressDialog" :append-to-body="true" title="Course address">
            <div class="form-item">
                <label class="form-title">Copy course link: </label>
                <div class="form-content">
                    <el-input v-model="courseAddressForm.roomsite" class="input-link" placeholder="Copy course link"></el-input>
                </div>
            </div>
            <div class="form-item">
                <label class="form-title">Course code: </label>
                <div class="form-content">
                    <el-input style="width:40%;" v-model="courseAddressForm.roomcode" placeholder="Course code"></el-input>
                </div>
            </div>

            <div class="box-foot">
                <div class="my-button cancel" @click="courseAddressDialog=false">CANCEL</div>
                <div class="my-button" @click="handleUpdateRoom" v-loading="updateRoomLoading">SURE</div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
import { format } from '@/utils/comm';
import ValidateButton from "@/views/Pc/Component/ValidateButton";
import _ from 'lodash';
import ScheduleTable from "@/views/Pc/Component/ScheduleTable";
import KtPag from "@/views/Comm/KtPag";
export default {
    components: {
        ScheduleTable,
        ValidateButton,
        KtPag
    },
    computed: {
        currentDate() {
            return format(this.selectedDay, 'ddd, MMMM DD, yyyy')
        }
    },
    data() {
        return {
            teachLessonList: [],//子课程
            format: format,
            statusMap: {
                '0': require('@/assets/icon/status_ing.png'),
                '1': require('@/assets/icon/status_unstarted.png'),
                '2': require('@/assets/icon/status_done.png')
            },
            lessonMap: {
                '-1': 'Invalid lesson',//无效
                '0': 'Pending appointment',//待预约
                '1': 'Appointment success',//预约成功
                '2': '取消',
                '3': '上课中',
                '4': '待确认',
                '5': '课程完成'
            },


            courseAddressDialog: false,//课程详情中的课程地址
            courseAddressForm: {
                roomsite: '',
                roomcode: '',
                id: ''
            },
            selectedDay: new Date(),
            canGoPre: true,
            teacherCalendar: [],
            teacherCourseByDate: [],
            recentCourse: [],
            updateRoomLoading: false,
            defaultParams: {
                type: 2,
                unused: 1,
                page: 1,
                limit: 10,
                count: 0,
            },
        }
    },
    watch: {
        selectedDay: function (newVal, oldVal) {
            let t = new Date()

            if (newVal.valueOf() < new Date(t.getFullYear(), t.getMonth() + 1, 1).valueOf()) {
                this.canGoPre = true
            } else {
                this.canGoPre = false
            }
            this.$nextTick(() => {

                this.getDayCalendarByDate();
            })
        }
    },
    created() {
    },
    mounted() {
        this.initPage();
    },
    methods: {
        initPage() {

            this.getTeacherMonthCalendar();
            this.getDayCalendarByDate();
            this.getrecentCourse();

        },
        search() {

        },
        getTeacherMonthCalendar() {//获取有课的日期
            let today = this.$refs['teacher-home-calendar'].curMonthDatePrefix.split('-');
            let params = {
                year: today[0],
                month: today[1]
            }
            this.$api.courseApi.getTeacherMonthCalendar(params).then(res => {
                if (res.status === '0') {
                    this.teacherCalendar = res.data
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getDayCalendarByDate() {
            this.$api.courseApi.getDayCalendar({ apdate: this.$refs['teacher-home-calendar'].formatedDate }).then(res => {
                if (res.status === '0') {
                    this.teacherCourseByDate = res.data
                } else {
                    this.$message.error(res.message);
                }
            })
        },
        getrecentCourse() {
            let params = { ...this.defaultParams };
            delete params.count;
            this.$api.courseApi.getLessons(params).then(res => {
                if (res.status === '0') {
                    this.defaultParams.count = res.data.count;
                    this.recentCourse = res.data.rows;
                }
            })
        },

        onPageChange({ page, limit }) {
            this.defaultParams.page = page;
            this.defaultParams.limit = limit;
            this.getrecentCourse();
        },

        //上个月
        preMonth() {
            this.$refs['teacher-home-calendar'].selectDate('prev-month');
            this.$nextTick(() => {
                this.getTeacherMonthCalendar();
            })

        },
        toToday() {
            this.$refs['teacher-home-calendar'].selectDate('today')
        },
        //下个月
        nextMonth() {
            this.$refs['teacher-home-calendar'].selectDate('next-month');
            this.$nextTick(() => {
                this.getTeacherMonthCalendar();
            })
        },
        //打开地址
        openCourseAddressDialog(item) {
            this.courseAddressForm.roomcode = item.roomcode || '';
            this.courseAddressForm.roomsite = item.roomsite || '';
            this.courseAddressForm.id = item.id;
            this.courseAddressDialog = true;
        },

        //更新上课url
        handleUpdateRoom() {
            let params = { ...this.courseAddressForm }
            if (!(params.roomsite || params.roomcode)) {
                return
            }

            this.updateRoomLoading = true;
            this.$api.courseApi.updateCourseCalendar(params).then(res => {
                if (res.status === '0') {
                    this.getrecentCourse();
                    this.courseAddressDialog = false;
                    this.$message.success('Success!');
                } else {
                    this.$message.error('Error! Reason:' + res.message);
                }
                this.updateRoomLoading = false;
            })
        },
        beginClass(item) {
            this.$confirm('Are you sure you want to start the course?', '', {
                type: 'warning'
            }).then(() => {
                this.$api.courseApi.beginLession({ id: item.id }).then(res => {
                    if (res.status === '0') {
                        this.$message.success(res.message);
                        this.getrecentCourse();
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(err => { })
        },
        finishClass(item) {
            this.$confirm('End session?', '', {
                type: 'warning'
            }).then(() => {
                this.$api.courseApi.finishLession({ id: item.id }).then(res => {
                    if (res.status === '0') {
                        this.$message.success(res.message);
                        this.getrecentCourse();
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(err => { })
        },

    }
}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.flex_1,
.flex_2,
.flex_3,
.flex_4,
.flex_5,
.flex_6,
.flex_7 {
    padding: 0 6px;
    align-self: center;
}
.flex_1 {
    flex: 1;
}
.flex_2 {
    flex: 2;
}
.flex_3 {
    flex: 3;
}
.flex_4 {
    flex: 4;
}
.flex_5 {
    flex: 5;
}
.flex_6 {
    flex: 6;
}
.flex_7 {
    flex: 7;
}

.operation {
        color: #f48c06;
    span {
        padding: 0 8px 0 0;
        color: #f48c06;
        cursor: pointer;
        // word-wrap: ;
        &:hover {
            text-decoration: underline;
        }
    }
}

.flex-box {
    display: flex;
    height: 100%;
    align-items: center;
}
.info-box {
    height: 100%;
}

//限制长度
.limit-length {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.techer-info-home {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    .top {
        // padding: 24px;
        padding-bottom: 24px;
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        background: #ffffff;
        .top-title {
            padding: 24px 24px 0 24px;
            font-size: 24px;
            font-weight: 600;
            color: #181d2c;
            line-height: 44px;
        }
        .calendar-box {
            display: flex;
            margin-top: 24px;
            /deep/.el-calendar {
                padding-left: 16px;
                .el-calendar__header {
                    display: none;
                }
                .el-calendar__body {
                    padding: 0;
                    .el-calendar-table {
                        width: auto;
                        thead {
                            font-size: 14px;
                            th {
                                width: 40px;
                                display: inline-block;
                                padding: 0 2px 8px 2px;
                                color: #181d2c;
                            }
                        }
                        tbody {
                            td {
                                margin: 0 2px;
                                width: 40px;
                                display: inline-block;
                                border-radius: 50%;
                                border: none !important;
                                .el-calendar-day {
                                    padding: 8px;
                                    width: 24px;
                                    height: 24px;
                                    border-radius: 50%;
                                    text-align: center;
                                    box-sizing: content-box;
                                    &:hover {
                                        background: #fdf3e6;
                                    }
                                    .has-course {
                                        color: #f48c06;
                                    }
                                }
                            }
                            tr:last-child {
                                display: none !important;
                            }
                            .is-selected {
                                background: #fdf3e6;
                            }
                            .is-today {
                                color: #f48c06;
                            }
                            .prev,
                            .next {
                                visibility: hidden;
                            }
                        }
                    }
                }
            }
            .calendar-header {
                // padding-left: 24px;
                font-weight: 600;
                padding: 0 4px 0 24px;
                font-size: 18px;
                display: flex;
                justify-content: space-between;
                margin-bottom: 20px;
                .can-select {
                    color: #181d2c;
                    cursor: not-allowed !important;
                    pointer-events: none !important;
                }
                i {
                    cursor: pointer;
                    color: #f48c06;
                }
            }

            .top-course {
                width: calc(100% - 372px);
                padding: 0 24px 0 24px;
                .calendar-header {
                    padding: 0;
                    margin-bottom: 12px;
                }
                .course-by-date-box {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 14px;
                    .item_l {
                        margin: 8px 12px 8px 0;
                    }
                    .item_r {
                        margin: 8px 0 8px 12px;
                    }
                    .course-by-date-item {
                        box-sizing: border-box;
                        width: calc(50% - 12px);
                        border-radius: 8px;
                        padding: 11px 14px;
                        background: rgba(32, 16, 2, 0.04);
                        .c-title {
                            line-height: 20px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                        .c-time {
                            margin-top: 2px;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }

    .myinfo-mid-content {
        margin-top: vw(32);
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        background: #ffffff;
        .list-head,
        .list-content {
            display: flex;
            padding: vw(24) vw(32);
            box-sizing: border-box;
        }
        .list-head {
            min-height: 73px;
            height: vw(73);
            font-size: 18px;
            color: #201002;
        }
        .list-content {
            min-height: 148px;
            height: vw(148);
            border-top: 1px solid #dbd9d6;
            font-size: 14px;
            .info-img {
                width: 38%;
                height: 100%;
                border-radius: 16px;
                display: inline-block;
            }
        }
    }

    .teach-course-information {
        box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        background: #ffffff;
        .list-head,
        .list-content {
            display: flex;
            padding: vw(24) vw(32);
            box-sizing: border-box;
        }
        .list-head {
            min-height: 72px;
            height: vw(72);
            font-size: 18px;
            color: #201002;
        }
        .list-content {
            min-height: 72px;
            height: vw(72);
            border-top: 1px solid #dbd9d6;
            font-size: 14px;
            .operation {
                span {
                    color: #f48c06;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }
    .kt-page{
        text-align: right;
    }
}

.box-foot {
    margin-top: 46px;
    display: flex;
    justify-content: center;
    font-size: 14px;
}
.my-button {
    cursor: pointer;
    width: 120px;
    height: 48px;
    background: #f48c06;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    span {
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
    }
}
.cancel {
    margin-right: 24px;
    background: #f2f2f2;
    color: #201002;
}
</style>